var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 -1 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8,18 C12.4162975,18 15.9967846,14.4215268 16,10.0059528 C16.0032111,5.59759276 12.4083905,2 7.99996742,2 C5.79079433,2 3.79114112,2.8956967 2.34356067,4.34356067 L0.660817703,2.6608177 C0.416960629,2.41696063 0,2.58968616 0,2.93453868 L0,7.54838635 C0,7.762159 0.173324069,7.93548307 0.387096722,7.93548307 L5.00094439,7.93548307 C5.34579691,7.93548307 5.51852244,7.51855395 5.27463387,7.27466537 L3.52857185,5.52857185 C4.6723469,4.38460779 6.25280284,3.67741913 8,3.67741913 C11.4947691,3.67741913 14.3225787,6.50576426 14.3225787,10 C14.3225787,13.4947691 11.4942336,16.3225787 8,16.3225787 C6.3836937,16.3225787 4.91009259,15.7176141 3.79287373,14.7215835 C3.63971095,14.5850222 3.40568251,14.5942838 3.26058424,14.7393821 L2.62386557,15.3761008 C2.46673354,15.5332643 2.47448303,15.7894702 2.63942757,15.9384432 C4.05799467,17.2197875 5.93787723,18 8,18 Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.9558cfab.svg";
export { ForwardRef as ReactComponent };